import { Link } from 'react-router-dom'

import '../assets/css/App.css';
import muda from '../assets/img/muda.png'

function Home() {
  return (
    <div className="App">
      <center>
      <img src={muda} width="92%" />
      </center>
      <br /><br />
      <h1>Selamat Datang di BRImo</h1>
      <p>Apakah Anda Memiliki Akun<br/>Internet Banking Bank BRI?</p>
      <div className="btn-container">
        <Link to='/tarif'>
        <button>Punya Akun</button>
        </Link>
        <span className="btn-non">
          Belum Punya Akun
        </span>
      </div>
      
    </div>
  );
}

export default Home;
